import React, { useState, useRef, useEffect } from 'react';
import Transition from '../../utils/Transition';
function FilterOrganizationButton({ 
  lastLogin,
  setLastLogin,
  setClick,
  click,
  sortedBy,
  setSortedBy
  }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);


  const trigger = useRef(null);
  const dropdown = useRef(null);

  // close on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownOpen &&
        dropdown.current &&
        !dropdown.current.contains(event.target) &&
        !trigger.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [dropdownOpen]);

  // close if the esc key is pressed
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const clearFilter = () => {
    setSearch(''); // Clear the filter query
    setClick(!click);
    setLastLogin(false)
  };
// Ensure only one sort option is checked
const handleSortChange = (sortType) => {
  if (sortedBy === sortType) {
    setSortedBy(null); // Deselect if already selected
  } else {
    setSortedBy(sortType); // Select new sort type
  }
};



  return (
    <div className="relative inline-flex space-x-4">
    {/* Bouton de filtre */}
    <button
        ref={trigger}
        className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-500 hover:text-slate-600"
        onClick={() => setDropdownOpen(!dropdownOpen)}
        aria-haspopup="true"
        aria-expanded={dropdownOpen}
      >
        <span className="sr-only">Filter</span>
        <svg
          className="w-4 h-4 fill-current"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 10l5 5 5-5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {/* Transition pour les filtres */}
      <Transition
         show={dropdownOpen}
         tag="div"
         className="origin-top-right z-10 absolute top-full left-0 right-auto md:left-auto md:right-0 min-w-56 bg-white border border-slate-200 pt-1.5 rounded shadow-lg overflow-hidden mt-1"
         enter="transition ease-out duration-200 transform"
         enterStart="opacity-0 -translate-y-2"
         enterEnd="opacity-100 translate-y-0"
         leave="transition ease-out duration-200"
         leaveStart="opacity-100"
         leaveEnd="opacity-0"
       >
        <div ref={dropdown}>
          <div className="text-xs font-semibold text-slate-400 uppercase py-1.5 pb-2 px-4">Filters</div>
          {/* User type filter */}
          <ul className="mb-4">
            <li className="py-1 px-3">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  checked={sortedBy === 'updatedAt'}
                  onChange={() => handleSortChange('updatedAt')}
                />
                <span className="text-sm font-medium ml-2">
                  Sort by updatedAt
                </span>
              </label>
            </li>
            <li className="py-1 px-3">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  checked={sortedBy === 'createdAt'}
                  onChange={() => handleSortChange('createdAt')}
                />
                <span className="text-sm font-medium ml-2">
                  Sort by createdAt
                </span>
              </label>
            </li>
            <li className="py-1 px-3">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  checked={sortedBy === 'industry'}
                  onChange={() => handleSortChange('industry')}
                />
                <span className="text-sm font-medium ml-2">
                  Sort by industry
                </span>
              </label>
            </li>
            <li className="py-1 px-3">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  checked={sortedBy === 'country'}
                  onChange={() => handleSortChange('country')}
                />
                <span className="text-sm font-medium ml-2">
                  Sort by country
                </span>
              </label>
            </li>
          </ul>
        </div>
      </Transition>
    </div>
  );
}

export default FilterOrganizationButton;
